'use strict';

const logColors = {
	error: 'background: #242424; color: red',
	warning: 'background: #242424; color: yellow;',
	pass: 'background: #242424; color: green;',
	info: 'background: #242424; color: cyan;',
	debug: 'background: #242424; color: blue;',
	event: 'background: #242424; color: saddlebrown;',
	step: 'background: #242424; color: magenta;',
};

/**
 * Checks if the query string is available currently supports
 * log-ad-tech=error
 * log-ad-tech=info
 * log-ad-tech=all
 * Or you can use an array of values to display specific messages
 * ?log[]=info&log[]=error&log[]=warning
 *
 * @param {string} string The string to assess.
 *
 * @return {boolean} Is the log a query string present in the url.
 */
const checkUrlQueryString = ( string ) => {
	const url = window.location.href;
	let result = false;
	if ( url.indexOf( '?log-ad-tech=' + string ) !== -1 || url.indexOf( '&log-ad-tech=' + string ) !== -1 ||
		url.indexOf( '?log-ad-tech[]=' + string ) !== -1 || url.indexOf( '&log-ad-tech[]=' + string ) !== -1 ) {
		result = true;
	}
	return result;
}

const logMessage = ( logDetails ) => {
	// Ensure logDetails message is present as its required.
	if ( 'undefined' !== typeof logDetails.message ) {
		// Open a group.
		if ( 'undefined' !== typeof logDetails.details ) {
			console.group();
		}

		if ( 'undefined' !== typeof logDetails.message ) {
			console.log( '%c📰 Ad Tech - ' + logDetails.message, logColors[ logDetails.type ] );
		} else {
			console.log( logDetails.message );
		}

		// Close the group.
		if ( 'undefined' !== typeof logDetails.details ) {
			console.log( logDetails.details );
			console.groupEnd();
		}
	} else {
		console.group();
		console.log( '%c📰 Ad Tech - Issue with use of adTechLog(), please ensure the correct object format is passed to adTechLog() function, in form of:', logColors.error );
		console.log( {
			type: 'String either error, warning, pass, info, debug or step',
			message: 'Message to be highlighted for details.',
			details: 'Optional/Object of mixed values',
		} );
		console.groupEnd();
	}
}

/**
 * Logger to log to console if query string is present in url.
 *
 * Message is displayed in correct color for type. Details can be a array, object,
 * Type can be one of error, warning, info or pass.
 *
 * @param {Object} logDetails = {type: 'string', message: 'string', details = 'mixed'}
 * logDetails.type        String either error, warning, info or pass.
 * logDetails.message    Message to be highlighted for details.
 * logDetails.details    Details.
 */
export const adTechLog = ( logDetails = {} ) => {
	// Ensure that the query string is one of, error, warning, info, pass or all.
	if ( checkUrlQueryString( 'info' ) || checkUrlQueryString( 'pass' ) ||
		checkUrlQueryString( 'debug' ) || checkUrlQueryString( 'event' ) ||
		checkUrlQueryString( 'all' ) || checkUrlQueryString( 'step' ) ) {

		if ( 'undefined' !== typeof console && console.log !== undefined ) {
			// Ensure only matching type logs get displayed.
			if ( 'undefined' !== typeof logDetails.type &&
				( checkUrlQueryString( logDetails.type ) || checkUrlQueryString( 'all' ) ) ) {
				// Error and warnings are handled differently, always displayed.
				if ( 'undefined' !== typeof logDetails.type && ( logDetails.type !== 'error' && logDetails.type !== 'warning' ) ) {
					// Log errors and warnings.
					logMessage( logDetails );
				}
			}
		}
	}

	if ( 'undefined' !== typeof logDetails.type && ( logDetails.type === 'error' || logDetails.type === 'warning' ) ) {
		// Log errors and warnings.
		logMessage( logDetails );
	}
}
